import { useQuery } from '@tanstack/react-query';
import { fetchAquariums, type Aquarium } from '../services/aquariumService';

export interface UseAquariumsResult {
  data: Aquarium[] | undefined;
  isLoading: boolean;
  error: Error | null;
  /** Re-runs the aquarium list request (e.g. the Retry button of a load error). */
  refetch?: () => void;
}

export function useAquariums(): UseAquariumsResult {
  const { data, isLoading, error, refetch } = useQuery<Aquarium[], Error>({
    queryKey: ['aquariums'],
    queryFn: fetchAquariums,
  });

  return {
    data,
    isLoading,
    error: error ?? null,
    refetch: () => {
      void refetch();
    },
  };
}
